import { searchVolopsSegments } from 'modules/search/routing/search.route-segments';
import { searchVolopsRouteReference } from 'modules/search/routing/search.routes';
import type { SearchVolopFiltersByName } from 'modules/search/types/FiltersByName/SearchVolopFiltersByName';
import type { SearchSortType } from 'modules/search/types/SearchSortType';

import { searchGetQueryParamsFromFiltersByName } from './searchGetQueryParamsFromFiltersByName';

type Args = {
  lang: UserLocale;
  q?: string;
  radius?: 'state' | 'country' | string | null;
  filtersByName?: Omit<SearchVolopFiltersByName, 'type'>;
  sort?: SearchSortType;
  pageIndex?: number;
};

export function searchGetVolopsRoutePath({
  lang,
  filtersByName,
  q,
  radius,
  sort,
  pageIndex,
}: Args) {
  const segment = searchVolopsSegments[lang];

  const queryParams = searchGetQueryParamsFromFiltersByName(filtersByName);
  if (q) queryParams.q = q;
  if (radius) queryParams.radius = radius;
  if (sort && sort !== 'relevance') queryParams.sort = sort;
  if (pageIndex) queryParams.page = pageIndex + 1;

  return searchVolopsRouteReference.with({ lang, segment, ...queryParams });
}
